import { Button, Dropdown, Icon } from '@symphony-ui/uitoolkit-components';
import useOption from 'components/customHooks';
import Company from '../../../../../admin/models/Company';
import CompanyFormModal from '../../../../../admin/pages/companies/CompanyFormModal';
import * as React from 'react';
import ApiServerURL from 'models/ApiServerUrl';
import ApiServerRequest from 'models/ApiServerRequest';
import DownloadContext from 'contexts/DownloadContext';
import { sendFetchError } from 'utils/messageUtils';
import PopupContext from 'contexts/PopupContext';
const CompanySelector = ({ companyId, disabled, label, onChange, selectedCompany, setSelectedCompany, style }) => {
    const { setBlockClose } = React.useContext(PopupContext);
    const [showModal, setShowModal] = React.useState(false);
    const [company, setCompany] = React.useState();
    const [loading, setLoading] = React.useState(false);
    const { apiFetchJson } = React.useContext(DownloadContext);
    const companyOptions = useOption('/admin/companies/ISSUER/options');
    const onChangeCompany = React.useCallback((event) => {
        const eventValue = event.target.value;
        const newValue = eventValue.value;
        onChange(newValue);
    }, [onChange]);
    const onClick = React.useCallback(() => {
        if (companyId !== undefined) {
            const url = new ApiServerURL('/admin/companies/find');
            url.searchParams.append('id', companyId);
            const request = new ApiServerRequest(url);
            setLoading(true);
            (async () => {
                try {
                    const body = await apiFetchJson(request);
                    const downloaded = new Company(body);
                    setCompany(downloaded);
                    setShowModal(true);
                }
                catch (error) {
                    sendFetchError("Unable to download company", error, request);
                }
                finally {
                    setLoading(false);
                }
            })();
        }
        else {
            setShowModal(true);
        }
    }, [apiFetchJson, companyId]);
    const onClose = React.useCallback(() => {
        if (setSelectedCompany !== undefined) {
            setSelectedCompany(undefined);
        }
        setShowModal(false);
    }, [setSelectedCompany]);
    const callback = React.useCallback((company) => {
        const { id } = company;
        if (id !== undefined) {
            if (setSelectedCompany !== undefined) {
                setSelectedCompany(undefined);
            }
            onChange(id);
        }
    }, [onChange, setSelectedCompany]);
    const onKeyUp = React.useCallback((event) => event.preventDefault(), []);
    const combinedStyle = React.useMemo(() => {
        const baseStyle = { display: 'flex', justifyContent: 'space-between' };
        return style !== undefined ? Object.assign(style, baseStyle) : baseStyle;
    }, [style]);
    return (React.createElement("div", { style: combinedStyle },
        showModal || selectedCompany !== undefined ?
            React.createElement(CompanyFormModal, { company: company, onClose: onClose, callback: callback, selectedCompany: selectedCompany })
            : undefined,
        React.createElement("div", { style: { width: '100%' } },
            React.createElement(Dropdown, { autoFocus: true, disabled: disabled, label: label, onChange: onChangeCompany, onMenuClose: () => setBlockClose(false), onMenuOpen: () => setBlockClose(true), onKeyUp: onKeyUp, options: companyOptions, style: { width: '100%' }, value: companyOptions.find(o => 'value' in o && companyId === o.value) })),
        React.createElement("div", { style: { alignSelf: 'end', marginLeft: '0.5rem' } },
            React.createElement(Button, { disabled: disabled, iconButton: true, loading: loading, onClick: onClick, size: 'small' },
                React.createElement(Icon, { iconName: 'search' })))));
};
export default CompanySelector;
